import Link from "next/link"
import { useEffect, useState } from "react"
import type { IconType } from "react-icons"
import headerNavLinks from "@/data/headerNavLinks"
import * as Io5Icons from "react-icons/io5"
import Image from "@/components/Image"

function NavIcon({ icon, size = 14 }: { icon?: IconType; size?: number }) {
	if (!icon) return null
	const Cmp = icon
	return <Cmp size={size} />
}

export function IconRenderer(iconName: string, size: number = 14) {
	const IconComponent = Io5Icons[iconName as keyof typeof Io5Icons]

	return IconComponent ? <IconComponent size={size} /> : null
}

export default function Header({ handleOpen, handleRemove, openClass }) {
	const [stickyHeader, setStickyHeader] = useState(false)

	// State to represent whether something is toggled or not
	const [isToggled, setToggled] = useState(false)

	// Function to toggle the value of 'isToggled'
	const toggleTrueFalse = () => setToggled(!isToggled)

	// Effect hook to add a scroll event listener
	useEffect(() => {
		const handleScroll = () => {
			setStickyHeader(window.scrollY > 200)
		}
		handleScroll()
		document.addEventListener("scroll", handleScroll)
		return () => document.removeEventListener("scroll", handleScroll)
	}, [])

	return (
		<>
			<header
				className={
					stickyHeader
						? "header sticky-bar stick bg-gray-900"
						: "header sticky-bar bg-gray-900"
				}
			>
				<div className="container">
					<div className="main-header">
						<div className="header-logo">
							<Link href={`/`}>
								<Image
									src="/static/images/broda_dev_logo2.svg"
									alt="broda dev logo"
									width={1000}
									height={1000}
								/>
							</Link>
						</div>
						<div className="header-nav">
							<nav className="nav-main-menu d-none d-xl-block">
								<ul className="main-menu">
									{headerNavLinks.map((link, key) =>
										link.children && link.children.length ? (
											<li className="has-children" key={key}>
												<div className="font-bold">
													<Link
														className="color-gray-500 d-flex align-items-center gap-2"
														href={link.href}
													>
														<NavIcon icon={link.icon} />
														{link.title} {IconRenderer("IoCaretDown")}
													</Link>
												</div>
												<ul className="sub-menu two-col">
													{link.children.map((child, key) => (
														<li key={key}>
															<Link
																className="color-gray-500"
																href={child.href}
															>
																{child.title}
															</Link>
														</li>
													))}
												</ul>
											</li>
										) : (
											<li key={key}>
												<Link
													className="color-gray-500 d-flex align-items-center gap-2"
													href={link.href}
												>
													<NavIcon icon={link.icon} />
													<span className="d-inline">{link.title}</span>
												</Link>
											</li>
										)
									)}
								</ul>
							</nav>
							<div
								className={`burger-icon burger-icon-white ${openClass && "burger-close"}`}
								onClick={() => {
									handleOpen()
									handleRemove()
								}}
							>
								<span className="burger-icon-top" />
								<span className="burger-icon-mid" />
								<span className="burger-icon-bottom" />
							</div>
						</div>
						<div className="header-right text-end">
							<Link
								className="btn btn-linear d-none d-sm-inline-block hover-up hover-shadow"
								href="/contact"
							>
								<span className="d-flex align-items-center gap-2">
									{IconRenderer("IoChatboxEllipses")} Contact
								</span>
							</Link>
						</div>
					</div>
				</div>
			</header>
		</>
	)
}
